import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// data-delay is either a plain millisecond count or a JSON {"show":…,"hide":…} pair.
const parseDelay = (value) => {
  if (!value) return 0
  return value.startsWith('{') ? JSON.parse(value) : Number(value)
}

export default class extends Controller {
  static targets = ['tooltip']

  connect() {
    this.tooltipTargets.forEach(tooltip => {
      const existingTooltip = bootstrap.Tooltip.getInstance(tooltip)
      if (existingTooltip) {
        existingTooltip.dispose()
      }
      new bootstrap.Tooltip(tooltip, {
        html: tooltip.dataset.html == "true" || false,
        // Bootstrap resolves placement with placement.toUpperCase(), so an
        // absent data-placement has to fall back rather than pass undefined.
        placement: tooltip.dataset.placement || 'top',
        // A Turbo cache snapshot keeps Bootstrap's title→data-bs-original-title
        // swap without the instance, so the title attribute is gone on restore.
        title: tooltip.title || tooltip.dataset.title || tooltip.dataset.bsOriginalTitle || '',
        // Call sites predating data-trigger relied on a hardcoded 'hover', so
        // that stays the fallback; opt in to 'hover focus' for keyboard users.
        trigger: tooltip.dataset.trigger || 'hover',
        delay: parseDelay(tooltip.dataset.delay),
        customClass: tooltip.dataset.customClass || '',
        // Default to 'body' container to prevent rendering issues in modals
        // where tooltips can be clipped by modal overflow/positioning.
        // 'self' renders the tooltip inside the trigger element itself: moving
        // the pointer into the tooltip then doesn't fire the trigger's
        // mouseleave, so a long tooltip stays open and can be scrolled.
        container: tooltip.dataset.container === 'self' ? tooltip : (tooltip.dataset.container || 'body')
      })
    })
  }

  disconnect() {
    this.tooltipTargets.forEach(tooltip => {
      const tooltipInstance = bootstrap.Tooltip.getInstance(tooltip)
      if (tooltipInstance) {
        tooltipInstance.dispose()
      }
    })
  }
}
